import React, { Component } from "react";
import { withRouter , Link } from 'react-router-dom';
import Footer from "../ui/Footer";
import Logo from '../../components/assets/logo/logo';
import './logs.css'


class Login extends Component {
    state = {username: null};

    submitForm (e) {
        e.preventDefault();
        this.props.history.push('/successfullLoged', {username: e.target.email.value}); 
    }

    render() {
        return (
            <div>
                <Link to={"/"}><Logo/></Link>
                <form onSubmit={this.submitForm.bind(this)}>
                <h1>Sign In</h1>

                <div className="input-container">
                    <label>Email address</label>
                    <input 
                        type="email" 
                        className="form-control"
                        name="email"
                        placeholder="Enter Your Email" />
                </div>

                <div className="input-container">
                    <label>Password</label>
                    <input 
                        type="password" 
                        className="form-control" 
                        name="password"
                        placeholder="Enter Your Password" />
                </div>

                <div className="input-container">
                    <div className="custom-control custom-checkbox">
                        <input type="checkbox" id="customCheck1" />
                        <label htmlFor="customCheck1" id="rememberMe">Remember Me</label>
                    </div>
                </div>

                <button type="submit" className="submit">Submit</button>
                <p className="input-container">Forgot &nbsp;<Link to="/resetpassword">Password?</Link></p>
            </form>

            <Footer/>
            </div>
        );
    }
}

export default withRouter(Login);